export const liftangoBrandApproval = {
  artifact: 'Liftango simulation UI palette constants',
  owner: 'Atlas frontend maintainers',
  approvalDate: '2026-02-24',
  referenceFiles: [
    'src/components/map/components/simulation-results/SimulationResultsSidebar.tsx',
    'src/components/map/components/simulation-results/OperationsView.tsx',
  ],
} as const;

export const liftangoBrandPalette = {
  primary: '#EE7334',
  primaryDark: '#D66023',
  secondary: '#7DC8C6',
  tertiary: '#3A3A48',
  neutral: '#F2F2F2',
  backgroundDefault: '#F2F2F2',
  backgroundPaper: '#FFFFFF',
  textPrimary: '#3A3A48',
  textSecondary: '#64748B',
  success: '#5FC98F',
  warning: '#FFA726',
  error: '#D14343',
  linkDefault: '#EE7334',
  linkHover: '#D66023',
  linkVisited: '#9C4E27',
} as const;

export const liftangoBrandTokens = {
  palette: liftangoBrandPalette,
  surface: {
    canvas: liftangoBrandPalette.backgroundDefault,
    primary: liftangoBrandPalette.backgroundPaper,
    secondary: '#F7F7F8',
    muted: '#ECECF0',
    elevated: '#FFFFFF',
    borderSubtle: 'rgba(58, 58, 72, 0.12)',
  },
  actionBrand: {
    primary: liftangoBrandPalette.primary,
    primaryHover: liftangoBrandPalette.primaryDark,
    secondary: '#2C2C36',
    secondaryHover: '#202029',
    inverted: '#3A3A48',
    outlinedBorder: 'rgba(58, 58, 72, 0.24)',
  },
  typography: {
    headline: '#15161C',
    body: '#5E4A4A',
    label: '#6A5B66',
  },
  mapSidebar: {
    buttonSurface: liftangoBrandPalette.backgroundPaper,
    buttonText: liftangoBrandPalette.textPrimary,
  },
  fixedRoutes: {
    drawerSurface: liftangoBrandPalette.backgroundPaper,
    drawerBorder: 'rgba(58, 58, 72, 0.12)',
    headerText: liftangoBrandPalette.textPrimary,
    subText: liftangoBrandPalette.textSecondary,
    tabActive: liftangoBrandPalette.primary,
    tabInactive: liftangoBrandPalette.textSecondary,
    tabBackground: '#F8FAFC',
    tabBorder: 'rgba(58, 58, 72, 0.12)',
    primaryActionBackground: liftangoBrandPalette.primary,
    primaryActionBackgroundHover: liftangoBrandPalette.primaryDark,
    primaryActionText: '#FFFFFF',
    secondaryActionBackground: '#FFFFFF',
    secondaryActionText: liftangoBrandPalette.textPrimary,
    secondaryActionBorder: 'rgba(58, 58, 72, 0.2)',
    contentSurface: '#FFFFFF',
    contentSurfaceMuted: '#F8FAFC',
    contentBorder: 'rgba(58, 58, 72, 0.1)',
  },
  // Intentional non-theme colors for domain encodings in simulation timelines.
  visualization: {
    pickupNode: '#5FC98F',
    dropoffNode: '#EE7334',
    neutralNode: '#3A3A48',
    /** Service start/end on dark backgrounds (e.g. activity detail panel); neutralNode matches sidebar and is invisible there */
    shiftNodeOnDark: '#5E5E6E',
  },
  simulationResults: {
    sidebarBackground: '#ffffff',
    sidebarText: '#171a1f',
    sidebarMutedText: '#52565e',
    sidebarBorder: '#e0e3e9',
    tooltipBackground: '#FFFFFF',
    tooltipText: '#171a1f',
    tooltipBorder: '#e0e3e9',
  },
  missionControl: {
    tripPickup: liftangoBrandPalette.primary,
    tripDropoff: liftangoBrandPalette.tertiary,
    tripLine: 'rgba(58, 58, 72, 0.45)',
    tripLineBorder: 'rgba(58, 58, 72, 0.55)',
    zoneFill: 'rgba(25, 118, 210, 0.12)',
    zoneBorder: 'rgba(13, 71, 161, 0.50)',
    zonePreviewFill: 'rgba(25, 118, 210, 0.10)',
    zonePreviewBorder: 'rgba(13, 71, 161, 0.44)',
  },
  /** Postcode assignment live map (`PostcodeAssignmentMapPanel`): origins, targets, connector styling */
  postcodeAssignmentMap: {
    origin: liftangoBrandPalette.success,
    hubTarget: '#7C3AED',
    osmStop: '#2563EB',
  },
} as const;
